import React from "react";

const BookList = props => {
  const handleInputChange = (event, idx) => {
    const { name, value } = event.target;
    const updatedBookDetails = [...props.bookDetails];
    updatedBookDetails[idx][name] = value;
    props.setBookDetails(updatedBookDetails);
  };

  return props.bookDetails.map((val, idx) => {
    let firstName = `firstName-${idx}`,
      lastName = `lastName-${idx}`,
      mobileNumber = `mobileNumber-${idx}`,
      whatsAppNumber = `whatsAppNumber-${idx}`,
      email = `email-${idx}`,
      age = `age-${idx}`;
    return (
      <div className="form-row" key={val.index}>
        <div className="side-by-side">
          <div className="textOnInput">
            <label htmlFor={firstName}>First Name</label>
            <input
              type="text"
              className="input2"
              data-id={idx}
              id={firstName}
              name="firstName"
              value={val.firstName}
              onChange={(e) => handleInputChange(e, idx)}
            />
          </div>
          <div className="textOnInput">
            <label htmlFor={lastName}>Last Name</label>
            <input
              type="text"
              className="input2"
              data-id={idx}
              id={lastName}
              name="lastName"
              value={val.lastName}
              onChange={(e) => handleInputChange(e, idx)}
            />
          </div>
        </div>
        <div className="side-by-side">
          <div className="textOnInput">
            <label htmlFor={mobileNumber}>Mobile Number</label>
            <input
              type="text"
              pattern="^[0-9]*[.,]?[0-9]*$"
              maxLength={10}
              data-id={idx}
              id={mobileNumber}
              name="mobileNumber"
              className="input2"
              value={val.mobileNumber}
              onChange={(e) => handleInputChange(e, idx)}
            />
          </div>
          <div className="textOnInput">
            <label htmlFor={whatsAppNumber}>WhatsApp Number</label>
            <input
              type="text"
              pattern="^[0-9]*[.,]?[0-9]*$"
              maxLength={10}
              data-id={idx}
              id={whatsAppNumber}
              name="whatsAppNumber"
              className="input2"
              value={val.whatsAppNumber}
              onChange={(e) => handleInputChange(e, idx)}
            />
          </div>
        </div>
        <div className="side-by-side">
          <div className="textOnInput">
            <label htmlFor={email}>Email</label>
            <input
              type="email"
              className="input2"
              data-id={idx}
              id={email}
              name="email"
              value={val.email}
              onChange={(e) => handleInputChange(e, idx)}
            />
          </div>
          <div className="textOnInput">
            <label htmlFor={age}>Age</label>
            <input
              type="number"
              className="input2"
              data-id={idx}
              id={age}
              name="age"
              value={val.age}
              onChange={(e) => handleInputChange(e, idx)}
            />
          </div>
        </div>
        <div className="col p-4">
          {idx === 0 ? (
            <a
              onClick={() => props.add()}
              type="button"
              className="btn-get-started-add"
            >
              <i className="fa fa-plus-circle" aria-hidden="true" />
              &nbsp; ADD PARTICIPANT
            </a>
          ) : (
            <a
              className="btn-get-started-delete"
              onClick={() => props.delete(val)}
            >
              <i className="fa fa-minus-circle" aria-hidden="true" />
              &nbsp; DELETE PARTICIPANT
            </a>
          )}
        </div>
      </div>
    );
  });
};

export default BookList;